import { RespuestaLecturaError } from '../Mensajes';
import { llamadaAPI_GET } from '../SQL';
import { TratamientoDeParametroParaURI } from '../Varios';

export const function_PRO_Fabricacion_Tipos_Listar = async () => {
    const NombreFuncion = "function_PRO_Fabricacion_Tipos_Listar"

    try {        
        const resulData = await llamadaAPI_GET("PRO_Fabricacion_Tipos/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};